import { _ as _slicedToArray, a as _toConsumableArray } from './_rollupPluginBabelHelpers-76ab84fa.js';
import React from 'react';
import { useStatePersist } from 'use-state-persist';
import { Link } from 'gatsby';
import dayjs from 'dayjs';

var JobListJobCard = function JobListJobCard(_ref) {
  var job = _ref.job,
      props = _ref.props,
      novaJob = _ref.novaJob;

  var _useStatePersist = useStatePersist('@savedJobs_' + props.apiKey, []),
      _useStatePersist2 = _slicedToArray(_useStatePersist, 2),
      savedJobs = _useStatePersist2[0],
      setSavedJobs = _useStatePersist2[1];

  function unsaveJob(id) {
    var newSavedJobsArray = savedJobs.filter(function (e) {
      return e !== id.toString();
    });
    setSavedJobs(newSavedJobsArray);

    if (trackEvent) {
      trackEvent({
        eventCategory: 'SmartFeedListComponent',
        eventAction: 'unsaveJob',
        eventLabel: encodeURIComponent(id)
      });
    }
  }

  function saveJob(id) {
    setSavedJobs(function (savedJobsOld) {
      return [].concat(_toConsumableArray(savedJobsOld), [id]);
    });

    if (trackEvent) {
      trackEvent({
        eventCategory: 'SmartFeedListComponent',
        eventAction: 'saveJob',
        eventLabel: encodeURIComponent(id)
      });
    }
  }

  var getSummary = function getSummary(summary, description) {
    if (summary) {
      return summary;
    } else {
      var alteredDescription = description.replace(/<[^>]*>?/gm, '');
      var tempSummary = alteredDescription.substring(0, 397);

      if (tempSummary.length === 397) {
        tempSummary += '...';
      }

      return tempSummary;
    }
  };

  function calculateSalary(Currency, SalaryFrom, SalaryTo, SalaryType, SalaryPeriod) {
    function numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    var NewSalary;
    var NewSalaryFrom;
    var NewSalaryTo;
    var currencyFormatted = Currency;

    if (Currency === '&pound;') {
      currencyFormatted = '£';
    }

    if (SalaryTo === 0) {
      NewSalary = SalaryType;
    } else if (typeof SalaryFrom === 'number' && typeof SalaryTo === 'number' && SalaryFrom === SalaryTo) {
      if (SalaryFrom >= 1000) {
        // Remove decimals
        NewSalaryFrom = currencyFormatted + numberWithCommas(SalaryFrom.toFixed());
      } else {
        // Add two decimals
        NewSalaryFrom = currencyFormatted + numberWithCommas(SalaryFrom.toFixed(2));
      }

      NewSalary = NewSalaryFrom + ' ' + SalaryPeriod;
    } else if (typeof SalaryFrom === 'number' && typeof SalaryTo === 'number') {
      if (SalaryFrom >= 1000) {
        NewSalaryFrom = currencyFormatted + numberWithCommas(SalaryFrom.toFixed());
      } else {
        NewSalaryFrom = currencyFormatted + numberWithCommas(SalaryFrom.toFixed(2));
      }

      if (SalaryTo >= 1000) {
        NewSalaryTo = currencyFormatted + numberWithCommas(SalaryTo.toFixed());
      } else {
        NewSalaryTo = currencyFormatted + numberWithCommas(SalaryTo.toFixed(2));
      }

      NewSalary = NewSalaryFrom + ' - ' + NewSalaryTo + ' ' + SalaryPeriod;
    } else {
      NewSalary = SalaryType;
    }

    return NewSalary;
  }

  var FormatDateTime = function FormatDateTime(JSONDate) {
    if (JSONDate) {
      // Set default values to avoid function breaking
      var expDate = new Date(parseInt(JSONDate.substr(6)));
      var dateFormatOptions = new Object({});
      dateFormatOptions.weekday = 'long';
      dateFormatOptions.year = 'numeric';
      dateFormatOptions.month = 'short';
      dateFormatOptions.day = 'numeric';
      return expDate.toLocaleDateString(undefined, dateFormatOptions);
    }

    return null;
  };

  var slugify = function slugify(text) {
    return text.toString() // Cast to string
    .toLowerCase() // Convert the string to lowercase letters
    .trim() // Remove whitespace from both sides of a string
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\-\-+/g, '-'); // Replace multiple - with single -
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "job-card-details"
  }, props.saveJobDisplay && /*#__PURE__*/React.createElement("div", {
    className: "job-card-savejob"
  }, /*#__PURE__*/React.createElement("div", {
    title: "Save this job for later",
    className: "job-card-savejob-trigger",
    role: "button",
    onClick: function onClick() {
      if (novaJob === true) {
        if (savedJobs.filter(function (e) {
          return e == job.id.toString();
        }).length > 0) {
          unsaveJob(job.id);
        } else {
          saveJob(job.id);
        }
      } else {
        if (savedJobs.filter(function (e) {
          return e == job.Id.toString();
        }).length > 0) {
          unsaveJob(job.Id);
        } else {
          saveJob(job.Id);
        }
      }
    }
  }, novaJob !== true && savedJobs.filter(function (e) {
    return e == job.Id.toString();
  }).length > 0 ? /*#__PURE__*/React.createElement("span", {
    className: "fas fa-heart"
  }) : novaJob === true && savedJobs.filter(function (e) {
    return e == job.id.toString();
  }).length > 0 ? /*#__PURE__*/React.createElement("span", {
    className: "fas fa-heart"
  }) : /*#__PURE__*/React.createElement("span", {
    className: "far fa-heart"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "job-card-title"
  }, /*#__PURE__*/React.createElement(Link, {
    to: novaJob === true || novaJob === 'true' ? props.VacancyPageBaseURL + '?jobId=' + job.id : props.VacancyPageBaseURL + new Buffer(job.Id).toString('base64') + '/' + slugify(job.JobTitle) + window.location.search
  }, job.JobTitle || job.title)), props.locationDisplay && /*#__PURE__*/React.createElement("div", {
    className: "job-card-location"
  }, job.Location || job.location), props.summaryDisplay && /*#__PURE__*/React.createElement("div", {
    className: "job-card-summary"
  }, novaJob === true ? getSummary(job.summary, job.content) : getSummary(job.Summary, job.Description)), props.referenceDisplay && /*#__PURE__*/React.createElement("div", {
    className: "job-card-reference"
  }, novaJob === true ? /*#__PURE__*/React.createElement(React.Fragment, null, "Reference: ".concat(job.referencenumber)) : /*#__PURE__*/React.createElement(React.Fragment, null, "Reference: ".concat(job.AdvertReference))), /*#__PURE__*/React.createElement("div", {
    className: "job-card-meta"
  }, props.locationDisplay && /*#__PURE__*/React.createElement("div", {
    className: "job-card-meta-item"
  }, /*#__PURE__*/React.createElement("span", null, "Location:"), props.regionDisplay && job.Region ? job.Region + ', ' : job.region ? job.region + ', ' : '', props.locationDisplay && job.Location ? job.Location + ', ' : job.location ? job.location + ', ' : '', props.subLocationDisplay && job.SubLocation ? job.SubLocation + ', ' : job.sublocation ? job.sublocation + ', ' : '', props.postcodeDisplay && job.PostCode ? job.PostCode + ', ' : job.postcode ? job.postcode + ', ' : '', props.countryDisplay && job.Country ? job.Country : job.country ? job.country : ''), props.jobTypeDisplay && /*#__PURE__*/React.createElement("div", {
    className: "job-card-meta-item"
  }, /*#__PURE__*/React.createElement("span", null, "Job Type:"), props.jobTimeDisplay && novaJob === true ? /*#__PURE__*/React.createElement(React.Fragment, null, job.jobtype + ' - ' + job.jobtypetime) : props.jobTimeDisplay && /*#__PURE__*/React.createElement(React.Fragment, null, job.JobType + ' - ' + job.JobTypeTime)), props.categoryDisplay && /*#__PURE__*/React.createElement("div", {
    className: "job-card-meta-item"
  }, /*#__PURE__*/React.createElement("span", null, "Category:"), job.JobCategory || job.jobcategory), props.salaryDisplay && /*#__PURE__*/React.createElement("div", {
    className: "job-card-meta-item"
  }, /*#__PURE__*/React.createElement("span", null, "Salary:"), novaJob === true ? calculateSalary(job.currency || '£', job.salaryfrom, job.salaryto, job.salarytype, job.salaryperiod) : calculateSalary(job.Currency, job.SalaryFrom, job.SalaryTo, job.SalaryType, job.SalaryPeriod)), props.expiryDateDisplay && /*#__PURE__*/React.createElement("div", {
    className: "job-card-meta-item"
  }, /*#__PURE__*/React.createElement("span", null, "Closing Date:"), novaJob === true ? dayjs(job.expirydate).format('dddd MMM YYYY') : FormatDateTime(job.ExpiryDate))), /*#__PURE__*/React.createElement("div", {
    className: "job-card-buttons-wrap"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "job-card-button btn btn-primary",
    to: novaJob === true || novaJob === 'true' ? props.VacancyPageBaseURL + '?jobId=' + job.id : props.VacancyPageBaseURL + new Buffer(job.Id).toString('base64') + '/' + slugify(job.JobTitle) + window.location.search
  }, "More details")));
};

export default JobListJobCard;